export default class TherapeuticArea {
	name: string;

	constructor(name: string) {
		this.name = name;
	}
}
